// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UEdM","index":"styles_index__QGWJk"};